import React, {forwardRef, useImperativeHandle, useState} from "react";
import {Button} from "antd";
import {useTranslation} from "react-i18next";
import styles from './shippings.module.css';

interface Props {
  dataKey: string;
  onReset?: () => void;
}

export const SelectedShippings = forwardRef(({onReset, dataKey}: Props, ref) => {
  const {t} = useTranslation("shipping");
  const [selectedShippings, setSelectedShippings] = useState<any[]>();
  
  console.log("SelectedShippings", dataKey, selectedShippings)
  useImperativeHandle(ref, () => ({
    setShippings: setSelectedShippings,
  }), []);
  return (<div className={styles.container + " wrapper-rd-wh-sm column "}>
    <div className={styles.list}>
      {selectedShippings && selectedShippings.map((s, idx) => (<div key={"check" + idx} className={styles.shipping}>
        {s[dataKey]}
      </div>))}
    </div>
    <Button
      type={"text"}
      className={styles.reset}
      onClick={onReset}
    >
      <span>{t("reset")}</span>
      <span>{selectedShippings?.length || 0}</span>
    </Button>
  </div>);
});